module.exports = __webpack_public_path__ + "static/img/05.acc5784.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/04/05.jpg
// module id = nuTU
// module chunks = 0